import { useEffect, useRef } from 'react'
import type { ResearchResult } from 'types'
import type { IntelligenceContext } from '../core/agents/types.js'
import { clientSessionViewStore } from '../../services/clientSessionViewStore.js'

type IntelligenceContextRef = Partial<IntelligenceContext>

/** Shared research/intelligence refs — subscribe once, no visual side effects. */
export function useResearchRefs() {
  const snapshot = clientSessionViewStore.getSnapshot()
  const researchResultRef = useRef<ResearchResult | null>(snapshot.researchContext ?? null)
  const intelligenceContextRef = useRef<IntelligenceContextRef>(snapshot.intelligenceContext || {})
  const userProfileRef = useRef<unknown>(null)

  useEffect(() => {
    const unsubscribe = clientSessionViewStore.subscribe(state => {
      researchResultRef.current = state.researchContext ?? null
      intelligenceContextRef.current = state.intelligenceContext || {}
    })
    return () => {
      unsubscribe()
    }
  }, [])

  return {
    researchResultRef,
    intelligenceContextRef,
    userProfileRef,
  }
}
